export const ACCOUNT_TYPE = {
  CUSTOMER: "Customer",
  SELLER: "Seller",
  ADMIN: "Admin",
}

export const COURSE_STATUS = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
}
